import React from "react";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

import Collapse from "../Collapse";
import Upload from "../Upload";

import { ReactComponent as AttachmentsIcon } from "../../assets/images/attachment-icon.svg";

import "./style.scss";

const Attachments = ({ values, errors, isReadOnly, setFieldValue }) => {
  const intl = useIntl();

  const [supportedExtensions] = useSelector(({ theme, user }) => [
    theme.DocumentType?.item?.Items?.map((item) => item.Value),
  ]);

  return (
    <Collapse
      defaultExpanded
      title={intl.formatMessage({
        id: "common.attachments",
      })}
      icon={<AttachmentsIcon />}
    >
      <Upload
        name="Attachments"
        label={intl.formatMessage({ id: "kpi.drop-file" })}
        error={errors.Attachments}
        onChange={(files) => setFieldValue("Attachments", files)}
        onDelete={(files) => setFieldValue("Attachments", files)}
        attachments={values.Attachments}
        disabled={isReadOnly}
        accept={{
          "image/*": supportedExtensions.map((item) => `.${item}`),
          "audio/*": supportedExtensions.map((item) => `.${item}`),
          "video/*": supportedExtensions.map((item) => `.${item}`),
          "text/*": supportedExtensions.map((item) => `.${item}`),
          "font/*": supportedExtensions.map((item) => `.${item}`),
          "application/*": supportedExtensions.map((item) => `.${item}`),
        }}
        multiple
      />
    </Collapse>
  );
};

export default Attachments;
